import DeviceTab from './DeviceTab'

export default DeviceTab
